export default __webpack_public_path__ + "static/media/Personal_Icon.2d8fc1bd.svg";